module.exports = __webpack_public_path__ + "static/media/nothing.fc182066.png";